import { useEffect } from 'react';
import { Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import ContratorLayout from '../Layouts/ContratorLayout';
import DashboardLayout from '../Layouts/DashboardLayout';
import EmployeeLayout from '../Layouts/EmployeeLayout';
import ProviderLayout from '../Layouts/ProviderLayout';

// outlets
import { CardDesignerOutlet } from '../Outlet/Employee/CardDesignerOutlet';
import { CardsOutlet } from '../Outlet/Employee/CardsOutlet';
import { CompanyOutlet } from '../Outlet/Employee/CompanyOutlet';
import { ContractorEmployeeOutlet } from '../Outlet/Employee/ContractorEmployeeOutlet';
import { ControllerOutlet } from '../Outlet/Employee/ControllerOutlet';
import { DevicesOutlet } from '../Outlet/Employee/DevicesOutlet';
import { EmployeeOutlet } from '../Outlet/Employee/EmployeeOutlet';
import { EventOutlet } from '../Outlet/Employee/EventOutlet';
import { GraphsOutlet } from '../Outlet/Employee/GraphsOutlet';
import { InputsOutlet } from '../Outlet/Employee/InputsOutlet';
import { OutputsOutlet } from '../Outlet/Employee/OutputsOutlet';
import { PayrollOutlet } from '../Outlet/Employee/PayrollOutlet';
import { ProviderEmployeeOutlet } from '../Outlet/Employee/ProviderEmployeeOutlet';
import { ReadersOutlet } from '../Outlet/Employee/ReadersOutlet';
import { SIOsOutlet } from '../Outlet/Employee/SIOsOutlet';
import { VehicleOutlet } from '../Outlet/Employee/VehicleOutlet';
import { ZoneOutlet } from '../Outlet/Employee/ZoneOutlet';

// Other
import NotFound from '../components/NotFound';
import RequireAuth from '../components/RequireAuth';
import Unauthorized from '../components/Unauthorized';
import Home from '../pages/Home/Home';

// Employee route import
import BackUp from '../pages/Dashboard/BackUp/backUp';
import { CompanyDetails } from '../pages/Dashboard/Company/CompanyDetails';
import RolesPanel from '../pages/Dashboard/Company/CompanyRoles/RolesPanel';
import CreateNewRole from '../pages/Dashboard/Company/CompanyRoles/Subcomponents/CreateNewRole';
import CreateNotifications from '../pages/Dashboard/Company/CreateNotifications';
import EmailSetting from '../pages/Dashboard/Company/EmailSetting';
import AllEmployees from '../pages/Dashboard/Company/Employees/AllEmployees';
import CreateEmployee from '../pages/Dashboard/Company/Employees/CreateEmployee';
import EmployeeDetail from '../pages/Dashboard/Company/Employees/EmployeeDetails/EmployeeDetail';
import UpdateEmployee from '../pages/Dashboard/Company/Employees/UpdateEmployee';
import ManageEmployeeDocs from '../pages/Dashboard/Company/Employees/subComponents/ManageEmployeeDocs';
import NotificationPanel from '../pages/Dashboard/Company/NotificationPanel/NotificationPanel';
import OnBoarding from '../pages/Dashboard/Company/OnBoarding/OnBoarding';
import OnBoardingUE from '../pages/Dashboard/Company/OnBoarding/OnBoardingUE';
import ManageAttendance from '../pages/Dashboard/Company/Payroll/Manage/Settings/ManageAttendance';
import Payroll from '../pages/Dashboard/Company/Payroll/Payroll';
import UpdateData from '../pages/Dashboard/Company/UpdateData';
import UserDocPanel from '../pages/Dashboard/Company/UserDocPanel';
import UserDocumentsEmployee from '../pages/Dashboard/Company/UserDocumentsEmployee';
import AllVehicles from '../pages/Dashboard/Company/Vehicles/AllVehicles';
import CreateVehicle from '../pages/Dashboard/Company/Vehicles/CreateVehicle';
import EmployeeVehicleDetail from '../pages/Dashboard/Company/Vehicles/EmployeeVehicleDetail';
import UpdateVehicle from '../pages/Dashboard/Company/Vehicles/UpdateVehicle';
import WorkShiftPanel from '../pages/Dashboard/Company/WorkShift/WorkShiftPanel';
import ContractDetails from '../pages/Dashboard/Contractors/ContractDetails';
import { CreateContract } from '../pages/Dashboard/Contractors/SubComponents/ContractCreateUpdateFlows/CreateContract';
import ContractorPanel from '../pages/Dashboard/Contractors/contractorPanel';
import CreateUpdateDevices from '../pages/Dashboard/Devices/CreateUpdateDevices';
import DevicesConfiguration from '../pages/Dashboard/Devices/DevicesConfiguration';
import DevicesPanel from '../pages/Dashboard/Devices/DevicesPanel';
import CreateEvent from '../pages/Dashboard/Events/Requested/CreateEvent';
import ShowDevices from '../pages/Dashboard/Zones/ShowDevices';
import SingleZoneDetails from '../pages/Dashboard/Zones/SubComponents/SingleZoneDetails';
import UpdateZone from '../pages/Dashboard/Zones/UpdateZone';
import Zones from '../pages/Dashboard/Zones/Zones';
import { EmployeeFlowCreateOrder } from '../pages/Provider/Order/SubComponents/OrderCreateUpdateFlows/EmployeeFlowCreateOrder';
// provider route import
import {useDispatch, useSelector} from 'react-redux';
import { permissionObj } from '../Helpers/permission';
import { HospitalityOutlet } from '../Outlet/Employee/HospitalityOutlet';
import Forbidden from '../components/Forbidden';
import EmployeContractDetail from '../pages/Contractor/Employee/EmployeContractDetail';

import { permissionRoutesObj } from '../Helpers/permissionRoutes';
import { FoodieOutlet } from '../Outlet/DiningOutlet';
import { ApprovalOutlet } from '../Outlet/Employee/ApprovalOutlet';
import DinningOrdersOutlet from '../Outlet/Employee/DinningOrdersOutlet';
import { HardDeleteOutlet } from '../Outlet/Employee/HardDelete';
import { contractorFile, supplierFile } from '../constant/userType';
import { ParamsContextProvider } from '../hooks/ParamsContextProvider';
import Approval from '../pages/Approval/Approval';
import ApprovalFlow from "../pages/Approval/ApprovalFlow";
import CardDesignerPanel from '../pages/CardDesigner/CardDesignerPanel';
import { CreateTemplate } from '../pages/CardDesigner/CreateTemplate';
import CardsPanel from '../pages/Cards/CardsPanel';
import EmployeeDetailsFromContractorFlowContract from "../pages/Contractor/Contracts/SubComponents/EmployeeDetailsFlows/EmployeeDetailsFromContractorFlowContract";
import VehicleDetailsFromContractFlowContract from "../pages/Contractor/Contracts/SubComponents/VehicleDetailsFlows/VehicleDetailsFromContractFlowContract";
import EditProfile from '../pages/Contractor/Profile/EditProfile';
import VehicalContractDetail from '../pages/Contractor/Vehicle/VehicalContractDetail';
import Access from '../pages/Dashboard/Access/Access';
import AddUpdateHeaders from '../pages/Dashboard/Company/Companyheaders/AddUpdateHeaders';
import VCardSettings from '../pages/Dashboard/Company/Employees/VCardSettings';
import AddUpdateHospitality from '../pages/Dashboard/Company/Hospitality/AddUpdateHospitality';
import Hospitality from '../pages/Dashboard/Company/Hospitality/Hospitality';
import RoomDetail from '../pages/Dashboard/Company/Hospitality/RoomDetail';
import AccessRights from '../pages/Dashboard/Contractors/AccessRights';
import UpdateContract from "../pages/Dashboard/Contractors/SubComponents/ContractCreateUpdateFlows/UpdateContract";
import EmployeeFlowContractorCreate from "../pages/Dashboard/Contractors/SubComponents/ContractorCreateUpdateFlows/EmployeeFlowContractorCreate";
import EmployeeFlowContractorUpdate from "../pages/Dashboard/Contractors/SubComponents/ContractorCreateUpdateFlows/EmployeeFlowContractorUpdate";
import EmployeeFlowContractorDetails from "../pages/Dashboard/Contractors/SubComponents/ContractorDetailsFlows/EmployeeFlowContractorDetails";
import ContractorCreateEmployee from "../pages/Dashboard/Contractors/SubComponents/EmployeeCreateUpdateFlows/ContractorCreateEmployee";
import ContractorUpdateEmployee from "../pages/Dashboard/Contractors/SubComponents/EmployeeCreateUpdateFlows/ContractorUpdateEmployee";
import Controller from '../pages/Dashboard/Controller/Controllers/Controller';
import CreateController from '../pages/Dashboard/Controller/Controllers/CreateController';
import Inputs from '../pages/Dashboard/Controller/Inputs/Inputs';
import Outputs from '../pages/Dashboard/Controller/Outputs/Outputs';
import Readers from '../pages/Dashboard/Controller/Readers/Readers';
import Department from '../pages/Dashboard/Department/Department';
import ManageDish from '../pages/Dashboard/Dining/Dishes/SubComponents/ManageDish';
import FoodieMain from '../pages/Dashboard/Dining/FoodieMain';
import AddEditIngredient from '../pages/Dashboard/Dining/Ingredients/SubComponents/AddEditIngredient';
import FoodieMainOrders from '../pages/Dashboard/DiningOrders/FoodieMainOrders';
import DistributionCenter from '../pages/Dashboard/DistributionCenter/DistributionCenter';
import Guard from '../pages/Dashboard/Guard/Guard';
import Logs from '../pages/Dashboard/Logs/Logs';
import DocumentRestriction from '../pages/Dashboard/Restrictions/DocumentRestriction';
import RestrictionUsers from '../pages/Dashboard/Restrictions/RestrictionUsers';
import UserRestriction from '../pages/Dashboard/Restrictions/UserRestriction';
import ServiceType from "../pages/Dashboard/ServiceType/ServiceType";
import SettingConfig from '../pages/Dashboard/Setting/SettingConfig';
import CreateUpdateRequest from "../pages/Dashboard/TransportRequest/CreateUpdateRequest";
import TransportRequest from "../pages/Dashboard/TransportRequest/TransportRequest";
import GraphsPanel from '../pages/Graphs/GraphsPanel';
import HardDelete from '../pages/HardDelete/HardDelete';
import Holiday from '../pages/Holiday/Holiday';
import CompanyPrivacyPolicy from '../pages/Legal/CompanyPrivacyPolicy';
import DataProcessingAgreement from '../pages/Legal/DataProcessingAgreement';
import RightToErasureRequestForm from '../pages/Legal/RightToErasureRequestForm';
import LoginOptions from '../pages/LoginOption/LoginOptions';
import CreationErrorsContractor from '../pages/Modals/CreationErrorsContractor';
import CreationErrorsContractorEmployee from '../pages/Modals/CreationErrorsContractorEmployee';
import CreationErrorsContractorVehicle from '../pages/Modals/CreationErrorsContractorVehicle';
import CreationErrorsEmployee from '../pages/Modals/CreationErrorsEmployee';
import CreationErrorsSuplierEmployee from '../pages/Modals/CreationErrorsSuplierEmployee';
import CreationErrorsSupplier from '../pages/Modals/CreationErrorsSupplier';
import CreationErrorsVehicle from '../pages/Modals/CreationErrorsVehicle';
import OrderDetail from '../pages/Provider/Order/SubComponents/OrderDetailsFlows/OrderDetail';
import EmployeeFlowSupplierCreate from "../pages/Provider/Supplier/SubComponents/SupplierCreateUpdateFlows/EmployeeFlowSupplierCreate";
import EmployeeFlowSupplierOrderDetail from "../pages/Provider/Order/SubComponents/OrderDetailsFlows/EmployeeFlowSupplierOrderDetail";
import EmployeeFlowSupplierUpdate from "../pages/Provider/Supplier/SubComponents/SupplierCreateUpdateFlows/EmployeeFlowSupplierUpdate";
import ProfileProvider from '../pages/Provider/Profile/ProfileProvider';
import ProvidersPanel from "../pages/Provider/ProvidersPanel";
import CompleteOrder from '../pages/Provider/Order/SubComponents/OrderDetailsFlows/CompleteOrder';
import SupplierFlowEmployeeCreate from "../pages/Provider/Supplier/SubComponents/SupplierCreateUpdateFlows/SupplierFlowEmployeeCreate";
import SupplierFlowEmployeeUpdate from "../pages/Provider/Supplier/SubComponents/SupplierCreateUpdateFlows/SupplierFlowEmployeeUpdate";
import SupplierFlowSupplierOrderDetail from "../pages/Provider/Order/SubComponents/OrderDetailsFlows/SupplierFlowSupplierOrderDetail";
import UserDocuments from '../pages/Provider/UserDocuments';
import ValidatedFail from '../pages/Veridas/FailValidation/ValidatedFail';
import ValidationFailNoExist from '../pages/Veridas/FailValidation/ValidationFailNoExist';
import DocumentPage from '../pages/Veridas/Integracion/Document/DocumentPage';
import VeridasOnboarding from '../pages/Veridas/VeridasOnboarding';
import BrowserCheck from '../pages/Veridas/browserEvent/BrowserCheck';
import WorkOffice from '../pages/WorkOffice/WorkOffice';
import MaterialRequestScanner from '../pages/MaterialRequestScanner/MaterialRequestScanner';
import DownloadApk from '../pages/appDownload/DownloadApk';
import CreateDish from './../pages/Dashboard/Dining/Dishes/SubComponents/CreateDish';
import CreationErrorsSuplierVehicle from './../pages/Modals/CreationErrorsSuplierVehicle';
import routes from './routes';
import CreateCafeteria from './../pages/Dashboard/Dining/Cafeteria/SubComponents/CreateCafeteria';
import UpdateCafeteria from './../pages/Dashboard/Dining/Cafeteria/SubComponents/UpdateCafeteria';
import CreateMenu from './../pages/Dashboard/Dining/Menu/SubComponents/CreateMenu';
import AddEditShift from '../pages/Dashboard/Dining/Schedules/SubComponents/AddEditShift';
import UpdateMenu from '../pages/Dashboard/Dining/Menu/SubComponents/UpdateMenu';
import UpdateVisitorType from "../pages/Dashboard/Visitor/Type/SubComponents/UpdateVisitorType";
import VisitorMain from "../pages/Dashboard/Visitor/VisitorMain";
import CreateVisitorType from "../pages/Dashboard/Visitor/Type/SubComponents/CreateVisitorType";
import InvitationDetails from "../pages/Dashboard/Visitor/Invitation/SubComponents/InvitationDetails";
import CreateVisitorInvitation from "../pages/Dashboard/Visitor/Invitation/CreateVisitorInvitation";
import { DiningKitchenOutlet } from '../Outlet/DiningKitchenOutlet';
import KitchenMain from '../pages/Dashboard/DiningKitchen/KitchenMain';
import SelectCoffeeShop from '../pages/Dashboard/DiningOrders/ContentSteps/DinningOrder/SelectCoffeeShop';
import SelectionMeals from '../pages/Dashboard/DiningOrders/ContentSteps/DinningOrder/SelectionMeals';
import BasketResume from '../pages/Dashboard/DiningOrders/ContentSteps/DinningOrder/BasketResume';
import ApprovalTracker from "../pages/Dashboard/ApprovalTracker/ApprovalTracker";
import Invitation from '../pages/Dashboard/Visitor/External/Invitation';
import IdentityValidation from '../pages/Dashboard/Visitor/External/IdentityValidation';
import ChooseValidationType from '../pages/Dashboard/Visitor/External/ChooseValidationType';
import RegistrationProcess from '../pages/Dashboard/Visitor/External/RegistrationProcess';
import CreateValidation from '../pages/Dashboard/Visitor/External/CreateValidation';
import {ExternalOutlet} from '../pages/Dashboard/Visitor/External/ExternalOutlet';
import CurrentlyUnderReview from '../pages/Dashboard/Visitor/External/CurrentlyUnderReview';
import PhotoLiveSelfiePage from "../pages/Veridas/Integracion/Selfie/PhotoLiveSelfiePage";
import SuccessValidationForm from '../pages/Veridas/SuccessValidation/SuccessValidationForm';
import SuccessfullyVerified from '../pages/Dashboard/Visitor/External/SuccessfullyVerified';
import {VisitorOutlet} from "../Outlet/Employee/VisitorOutlet";
import VisitorUpdate from "../pages/Dashboard/Visitor/Visitor/SubComponents/VisitorUpdate";
import InvitationDocumentation from "../pages/Dashboard/Visitor/Request/SubComponents/InvitationDocumentation";
import {InvitationDetailsOutlet} from "../Outlet/Employee/InvitationDetailsOutlet";
import InvitationIdentity from "../pages/Dashboard/Visitor/Request/SubComponents/InvitationIdentity";
import DocumentationValidation from "../pages/Dashboard/Visitor/External/Documentation/DocumentationValidation";
import CreateDocumentation from "../pages/Dashboard/Visitor/External/Documentation/CreateDocumentation";
import DocumentationUnderReview from "../pages/Dashboard/Visitor/External/Documentation/DocumentationUnderReview";
import GuardMain from '../pages/Dashboard/Visitor/Guard/GuardMain';
import { GuardOutlet } from '../Outlet/Employee/GuardOutlet';
import {GetUserByIdAtEntry} from "../reduxToolkit/authentication/AuthenticatonApi";
import {ROLE_NAME_DEFAULT_MODEL, USER_TYPE_MODEL, USER_TYPE_NAME_MODEL} from "../enums/userTypeEnum";
import VisitorIncomingInvitation from "../pages/Dashboard/Visitor/IncomingInvitation/VisitorIncomingInvitation";
import {QrRequestAccessOutlet} from "../pages/Dashboard/Visitor/QrRequestAccess/QrRequestAccessOutlet";
import QrRequestAccessMain from "../pages/Dashboard/Visitor/QrRequestAccess/QrRequestAccessMain";
import FindMySelfMain from "../pages/Dashboard/Visitor/QrRequestAccess/SubComponents/FindMySelfMain";
import IAmNewHereMain from "../pages/Dashboard/Visitor/QrRequestAccess/SubComponents/IAmNewHereMain";
import FindMySelfCreateVisitorMain from "../pages/Dashboard/Visitor/QrRequestAccess/SubComponents/FindMySelfCreateVisitorMain";
import TrafficMain from '../pages/Dashboard/Traffic/TrafficMain';
import TrafficOutlet from '../Outlet/Employee/TrafficOutlet';
import IconLibrary from "../pages/Libraries/IconLibrary";
import ReservationsMain from '../pages/Dashboard/Events/ReservationsMain';
import TrafficDetails from '../pages/Dashboard/Traffic/TrafficFines/SubComponents/TrafficDetails';
import GeofencesCreate from '../pages/Dashboard/Traffic/Manage/SubComponents/GeofencesCreate';
import GeofencesUpdate from '../pages/Dashboard/Traffic/Manage/SubComponents/GeofencesUpdate';
import { OrdersContextProvider } from '../pages/Dashboard/DiningOrders/Functionality/OrdersContextProvider';
import UpdateController from "../pages/Dashboard/Controller/Controllers/UpdateController";
import Sios from "../pages/Dashboard/Controller/SIOs/Sios";
import Acrs from "../pages/Dashboard/Controller/Acrs/Acrs";
import ReservationDetail from './../pages/Dashboard/Events/subComponents/ReservationDetail';
import IncomingContractors from "../pages/Dashboard/Guard/IncomingContractor/IncomingContractors";
import CreateUpdateDocumentationApprovalFlow from "../pages/DocumentationApprovalFlow/SubComponents/CreateUpdateDocumentationApprovalFlow";
import RequestDetails from '../pages/Dashboard/Contractors/RequestDocumentation/SubComponents/RequestDetails';
import CompanyDocumentation from "../pages/Contractor/Documentation/CompanyDocumentation";
import EquipmentAndMaterial from '../pages/Dashboard/Contractors/EquipmentAndMaterial/EquipmentAndMaterial';
import UpdateEquipmentMaterial from './../pages/Dashboard/Contractors/EquipmentAndMaterial/subComponents/UpdateEquipmentMaterial';
import CreateEquipmentMaterial from './../pages/Dashboard/Contractors/EquipmentAndMaterial/subComponents/CreateEquipmentMaterial';
import DetailsEquipmentMaterial from '../pages/Dashboard/Contractors/EquipmentAndMaterial/subComponents/DetailsEquipmentMaterial';
import AddEditShiftAccess from '../pages/Dashboard/Company/Payroll/Manage/ShiftAccess/AddEditShiftAccess';
import {AttendanceOutlet} from '../pages/Dashboard/Company/Payroll/Functionality/AttendanceOutlet';
import {PROFILE_MODEL} from "../pages/DocumentationApprovalFlow/Model/Model";
import EmployeeDetailsDocumentation
    from '../pages/Contractor/Contracts/SubComponents/EmployeeDetailsFlows/EmployeeDetailsDocumentation';
import VehicleDetailsDocumentation
    from '../pages/Contractor/Contracts/SubComponents/VehicleDetailsFlows/VehicleDetailsDocumentation';
import EmployeeSuppliersDetails from '../pages/Provider/Supplier/SubComponents/EmployeeSuppliersDetails';
import {STATUS_MODEL} from "../enums/statusEnum";
import CreateGeoFenceAttendance from "../pages/Dashboard/Company/Payroll/Manage/Geofence/SubComponents/CreateGeoFenceAttendance";
import UpdateGeoFenceAttendance
    from "../pages/Dashboard/Company/Payroll/Manage/Geofence/SubComponents/UpdateGeoFenceAttendance";
import IdentityDocumentsGrid from '../pages/Dashboard/Company/Employees/subComponents/IdentityDocumentsGrid';
import ContractorSupplierFoodieMain from "../pages/Dashboard/Contractors/Dining/ContractorSupplierFoodieMain";
import DeliveredServicesMain from '../pages/Dashboard/DeliveredServices/DeliveredServicesMain';
import { DeliveredServicesOutlet } from './../Outlet/DeliveredServicesOutlet';
import { DeliveredServicesContextProvider } from '../pages/Dashboard/DeliveredServices/Functionality/DeliveredServicesContextProvider';
import {MaterialRequestOutlet} from "../Outlet/Employee/MaterialRequestOutlet";
import MaterialRequestMain from "../pages/Dashboard/MaterialRequest/MaterialRequestMain";
import CreateMaterialRequest from "../pages/Dashboard/MaterialRequest/SubComponents/CreateMaterialRequest";
import ApprovalMaterialRequest from "../pages/Dashboard/MaterialRequest/SubComponents/Approval/ApprovalMaterialRequest";
import MaterialRequestDetails from "../pages/Dashboard/MaterialRequest/SubComponents/Details/MaterialRequestDetails";
import MaterialDispatch from "../pages/Dashboard/MaterialRequest/SubComponents/MaterialDispatch/MaterialDispatch";

const MainRoutes = () => {
    const token = sessionStorage?.getItem('bearerToken') || '';
    const { permission, getUserByIdAtEntry,user  } = useSelector((state) => state.authenticatioauthennSlice);
    const DEV = useSelector((state) => state?.CommonsSlice?.development);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();
    const roleName = getUserByIdAtEntry.roleName;
    const statusId = user?.data?.status?.id;

    useEffect(() => {
        if (user?.data?.userType?.name === USER_TYPE_NAME_MODEL.EMPLOYEE) {
            dispatch(GetUserByIdAtEntry())
        }
    }, []);

    useEffect(() => {
        if (token && !DEV) {
            Object.keys(permissionObj).map((key) => {
                if (
                    typeof permissionRoutesObj[key] !== 'undefined' &&
                    permissionRoutesObj[key].includes(
                        location?.pathname.replace(
                            /[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}/gi,
                            '',
                        ),
                    ) &&
                    !permission.includes(permissionObj[key])
                ) {
                    navigate(routes.forbidden);
                }
            });
        }
    }, [location]);

    return (
        <Routes>
            {/* legal-documents route */}
            <Route path='data-processing-agreement.pdf' element={<DataProcessingAgreement />} />
            <Route path='company-privacy-policy.pdf' element={<CompanyPrivacyPolicy />} />
            <Route path='right-to-erasure-request-form.pdf' element={<RightToErasureRequestForm />} />
            {/* Visitor route */}
            <Route path='verify-visitor/:userId' element={<VeridasOnboarding />} />
            <Route path='document-validation/:id' element={<DocumentPage />} />
            <Route path='document-validation/:id/:guardFlowId' element={<DocumentPage />} />
            <Route path='selfie-validation/:id/:validationId' element={<PhotoLiveSelfiePage />} />
            <Route path='selfie-validation/:id/:validationId/:guardFlowId' element={<PhotoLiveSelfiePage />} />
            <Route path='validation-fail/:id' element={<ValidatedFail />} />
            <Route path='validation-fail/:id/:guardFlowId' element={<ValidatedFail />} />
            <Route path='user-id-not-exist' element={<ValidationFailNoExist />} />
            <Route path={'success-validation/:id'} element={<SuccessValidationForm />} />
            <Route path={'success-validation/:id/:guardFlowId'} element={<SuccessValidationForm />} />
            <Route path='unsupported-browser' element={<BrowserCheck />} />
            <Route path={'icon-library'} element={<IconLibrary/>}/>
            {/* dashboard */}
            {/* protected route */}
            <Route element={<RequireAuth allowedRoles={['EMPLOYEE', 'SUPPLIER_IN_CHARGE', 'CONTRACTOR_IN_CHARGE']} />}>
                <Route path='/dashboard' element={<DashboardLayout />}>
                    <Route path='announcement-panel' element={<NotificationPanel />} />
                    <Route path='system-config' element={<SettingConfig />} />
                    {/* employee route start*/}
                    <Route element={<RequireAuth allowedRoles={['EMPLOYEE']} />}>
                        <Route path='employee' element={<EmployeeLayout />}>
                            <Route path='user-documents' element={<UserDocuments docType='employee' />} />
                            {/* @company */}

                            <Route path='announcement-panel' element={<NotificationPanel />} />
                            <Route path='profile' element={<ProfileProvider />} />
                            <Route index path='company' element={<CompanyDetails />} />

                            <Route path='company' element={<CompanyOutlet />}>
                                <Route path='user-documents' element={<UserDocumentsEmployee />} />
                                <Route path='document-panel' element={<UserDocPanel />} />
                                <Route path='update-data' element={<UpdateData />} />
                                <Route path='workshift-panel' element={<WorkShiftPanel />} />
                                <Route path='roles-panel' element={<RolesPanel />} />
                                <Route path='add-new-role' element={<CreateNewRole />} />
                                <Route path='add-update-role/:id' element={<CreateNewRole />} />

                                <Route path='create-announcement' element={<CreateNotifications />} />

                                {/* onboarding */}
                                <Route path='onboarding' element={<OnBoarding />} />
                                <Route path='onboarding-UE/:id' element={<OnBoardingUE />} />

                                {/* manage headers */}
                                <Route path='headers' element={<AddUpdateHeaders />} />
                            </Route>
                            {/* @zone */}
                            <Route index path='zones' element={<Zones />} />
                            <Route path='zones' element={<ZoneOutlet />}>
                                <Route path='single-zone-details/:id' element={<SingleZoneDetails key={location.pathname}/>} />
                                <Route path='show-devices/:id' element={<ShowDevices />} />
                                <Route path='update-zone/:id' element={<UpdateZone />} />
                                <Route path='create-device' element={<CreateUpdateDevices />} />
                                <Route path='update-device/:id' element={<CreateUpdateDevices />} />
                            </Route>

                            {/* @devices */}
                            <Route index path='devices' element={<DevicesPanel />} />
                            <Route path='devices' element={<DevicesOutlet />}>
                                <Route path='configuration' element={<DevicesConfiguration />} />
                                <Route path='create' element={<CreateUpdateDevices />} />
                                <Route path='update/:id' element={<CreateUpdateDevices />} />
                            </Route>

                            {/* @approval */}
                            <Route path='approval' element={<Approval />} />
                            <Route path='approval' element={<ApprovalOutlet />}>
                                <Route path='create' element={<ApprovalFlow />} />
                                <Route path='update/' element={<ApprovalFlow />} />
                            </Route>
                            {/* @cards */}
                            <Route index path='cards' element={<CardsPanel />} />
                            <Route path='cards' element={<CardsOutlet />}>
                                <Route path='create' element={<CreateUpdateDevices />} />
                            </Route>
                            {/* @graphs */}
                            <Route index path='graphs' element={<GraphsPanel />} />
                            <Route path='graphs' element={<GraphsOutlet />} />
                            {/* @dining */}
                            <Route path='foodie' element={
                                <ParamsContextProvider>
                                    <FoodieOutlet />
                                </ParamsContextProvider>
                            }>
                                {/* === Main */}
                                <Route path='main' element={<FoodieMain />} />
                                {/* === Cafeterias */}
                                <Route path='cafeteria/create' element={<CreateCafeteria />} />
                                <Route path='cafeteria/update' element={<UpdateCafeteria />} />
                                {/* === ingredients*/}
                                <Route path='ingredient/add-edit/' element={<AddEditIngredient />} />
                                <Route path='ingredient/add-edit/:id' element={<AddEditIngredient />} />
                                {/* === dishes*/}
                                <Route path='dishes/manage/:id' element={<ManageDish />} />
                                <Route path='dishes/create' element={<CreateDish />} />

                                {/* === Menu*/}
                                <Route path='menu/create/' element={<CreateMenu/>} />
                                <Route path='menu/update/:id' element={<UpdateMenu/>} />
                                <Route path='menu/details/:id' element={<UpdateMenu disabled={true}/>} />
                                <Route path='menu/clone' element={<UpdateMenu/>} />
                                {/* === Schedules shift*/}
                                <Route path='shift/add-edit/' element={<AddEditShift />} />
                                <Route path='shift/add-edit/:id' element={<AddEditShift />} />
                                {/* === Manage*/}
                            </Route>

                            {/* @Dining orders */}
                            <Route path='foodie-orders' element={
                                <OrdersContextProvider>
                                    <DinningOrdersOutlet />
                                </OrdersContextProvider>
                            }>
                                <Route path='main' element={<FoodieMainOrders />} />
                                <Route path='order' element={<SelectCoffeeShop />} />
                                <Route path='meals' element={<SelectionMeals />} />
                                <Route path='basket' element={<BasketResume />} />

                            </Route>

                            <Route path='kitchen' element={<DiningKitchenOutlet />}>
                                <Route path='main' element={<KitchenMain />} />
                            </Route>

                            <Route path='delivered-services' element={<DeliveredServicesOutlet />}>
                                <Route path='main' element={<DeliveredServicesContextProvider>
                                    <DeliveredServicesMain />
                                    </DeliveredServicesContextProvider>} />
                            </Route>

                            {/* @hardDelete */}
                            <Route index path='hard_delete' element={<HardDelete />} />
                            <Route path='hard_delete' element={<HardDeleteOutlet />} />
                            {/* @event */}
                            <Route path='events' element={<EventOutlet />}>
                                <Route path='main' element={<ReservationsMain />} />
                                <Route path='normal-events' element={<CreateEvent />} />
                                <Route path='reservation/:id' element={<ReservationDetail/>} />
                            </Route>
                            {/* @controller */}
                            <Route path='controller' element={<Controller />} />
                            <Route path='controller' element={<ControllerOutlet />}>
                                <Route path='create-controller' element={<CreateController />} />
                                <Route path='update/:id' element={<UpdateController />} />
                                {/*   aqui lo de el controller */}
                            </Route>
                            {/* @Readers */}
                            <Route path='readers' element={<Readers />} />
                            <Route path='readers' element={<ReadersOutlet />}>
                                {/*   aqui lo de el controller */}
                            </Route>
                            {/* @SIOs */}
                            <Route path='sios' element={<Sios />} />
                            <Route path='sios' element={<SIOsOutlet />}>
                                {/*   aqui lo de el controller */}
                            </Route>
                            {/* @Inputs */}
                            <Route path='inputs' element={<Inputs />} />
                            <Route path='inputs' element={<InputsOutlet />}>
                                {/*   aqui lo de el controller */}
                            </Route>
                            {/* @Outputs */}
                            <Route path='outputs' element={<Outputs />} />
                            <Route path='outputs' element={<OutputsOutlet />}>
                                {/*   aqui lo de el controller */}
                            </Route>
                            <Route path='acrs' element={<Acrs />} />
                            {/* @employees */}
                            <Route path='all-employees' element={<AllEmployees />} />
                            <Route path='all-employees' element={<EmployeeOutlet />}>
                                <Route path='employee-Detail/:id' element={<EmployeeDetail />} />
                                <Route path='add-employee' element={<CreateEmployee />} />

                                <Route path='errors' element={<CreationErrorsEmployee />} />{/**Done**/}
                                <Route path='update-employee/:id' element={<UpdateEmployee />} />
                                <Route path='identity-validation/:id' element={<IdentityDocumentsGrid/>} />
                                <Route path='employee-docs' element={<ManageEmployeeDocs approveDocument={false} />} />
                                <Route
                                    path='employee-docs-complete'
                                    element={<ManageEmployeeDocs approveDocument={true} />}
                                />
                            </Route>
                            {/* @Vehicle */}
                            <Route path='vehicle-fleet' element={<AllVehicles />} />
                            <Route path='vehicle-fleet' element={<VehicleOutlet />}>
                                <Route path='create-vehicle' element={<CreateVehicle />} />
                                <Route path='errors' element={<CreationErrorsVehicle />} />{/**Done**/}
                                <Route path='vehicle-detail/:id' element={<EmployeeVehicleDetail />} />
                                <Route path='update-vehicle/:id' element={<UpdateVehicle />} />
                            </Route>
                            {/* @Contractor */}
                            <Route index path='contractors' element={<ContractorPanel />} />
                            <Route path='contractors' element={<ContractorEmployeeOutlet />}>
                                <Route path='employee-detail/:id' element={<EmployeeDetailsDocumentation userType={USER_TYPE_MODEL.CONTRACTOR_IN_CHARGE} />}/>{/*Used*/}
                                <Route path='vehicle-detail/:id' element={<VehicleDetailsDocumentation userType={USER_TYPE_MODEL.CONTRACTOR_IN_CHARGE} />}/>{/*Used*/}

                                <Route path='create-contract' element={<CreateContract />} />
                                <Route path='update-contract' element={<UpdateContract />} />
                                <Route path='add-contractor' element={<EmployeeFlowContractorCreate />} />{/****Employee Flow: contractors -> contractors -> create ****/}
                                <Route path='update-contractor/:id' element={<EmployeeFlowContractorUpdate />} />{/****Employee Flow: contractors -> contractors -> update ****/}
                                <Route path='identity-validation/:id' element={<IdentityDocumentsGrid/>} />{/****Employee Flow: contractors -> contractors -> update ****/}
                                <Route path='errors' element={<CreationErrorsContractor />} />{/**Done**/}
                                <Route path='contract-details/:contractId' element={<ContractDetails />} />
                                <Route path='contractor-detail/:id' element={<EmployeeFlowContractorDetails />} />{/****Employee Flow: contractors -> contractors -> details ****/}
                                <Route path='create-approval-level' element={<CreateUpdateDocumentationApprovalFlow userTypeId={USER_TYPE_MODEL.CONTRACTOR_IN_CHARGE}/>} />{/*Used*/}
                                <Route path='update-approval-level/:id' element={<CreateUpdateDocumentationApprovalFlow userTypeId={USER_TYPE_MODEL.CONTRACTOR_IN_CHARGE}/>} />{/*Used*/}
                                <Route path='document-request-details/:id/:profile' element={<RequestDetails userTypeId={USER_TYPE_MODEL.CONTRACTOR_IN_CHARGE} />} />{/*Used*/}{/****Employee Flow: contractors -> RequestDocumentation -> Subcomponents -> request documents ****/}
                            </Route>
                            {/* @supplier */}
                            <Route index path='suppliers' element={<ProvidersPanel />} /> {/**Done**/}
                            <Route path='suppliers' element={<ProviderEmployeeOutlet />}> {/**Done**/}
                                <Route path='employee-detail/:id' element={<EmployeeDetailsDocumentation userType={USER_TYPE_MODEL.SUPPLIER_IN_CHARGE} />}/>{/*Used*/}
                                <Route path='vehicle-detail/:id' element={<VehicleDetailsDocumentation userType={USER_TYPE_MODEL.SUPPLIER_IN_CHARGE} />}/>{/*Used*/}

                                <Route path='create-order' element={<EmployeeFlowCreateOrder />} /> {/**Done**/}
                                <Route path='order-details/:id' element={<OrderDetail />} /> {/**Done**/}
                                <Route path='errors' element={<CreationErrorsSupplier />} /> {/**Done**/}
                                <Route path='add-suppliers' element={<EmployeeFlowSupplierCreate />} />  {/**Done**/}
                                <Route path='update-suppliers/:id' element={<EmployeeFlowSupplierUpdate />} />  {/**Done**/}
                                <Route path='identity-validation/:id' element={<IdentityDocumentsGrid/>} />  {/**Done**/}
                                <Route path='supplier-order-detail/:id' element={<EmployeeFlowSupplierOrderDetail />} /> {/**Done**/}
                                <Route path='suppliers-detail-page/:id' element={<EmployeeSuppliersDetails />} /> {/**Done**/}
                                <Route path='create-approval-level' element={<CreateUpdateDocumentationApprovalFlow userTypeId={USER_TYPE_MODEL.SUPPLIER_IN_CHARGE}/>} />{/*Used*/}
                                <Route path='update-approval-level/:id' element={<CreateUpdateDocumentationApprovalFlow userTypeId={USER_TYPE_MODEL.SUPPLIER_IN_CHARGE}/>} />{/*Used*/}
                                <Route path='document-request-details/:id/:profile' element={<RequestDetails userTypeId={USER_TYPE_MODEL.SUPPLIER_IN_CHARGE} />} />{/*Used*/}
                            </Route>

                            {/*Approval Tracker*/}
                            <Route path='approval-tracker/:module/:subjectId/:approvalFlowId' element={<ApprovalTracker/>}/>
                            <Route path='approval-tracker/details/:module/:subjectId/:approvalFlowId' element={<ApprovalTracker details={true}/>}/>


                            {/* @attendance */}
                            <Route
                                path="attendance"
                                element={
                                    <ParamsContextProvider>
                                        <AttendanceOutlet />
                                    </ParamsContextProvider>
                                }
                            >
                                <Route path="" element={<Payroll />} />
                                <Route path="manage-attendence" element={<ManageAttendance />} />
                                <Route path="email-setting" element={<EmailSetting />} />

                                {/** Shift access -> Add Edit **/}
                                <Route path="shift/add-edit/" element={<AddEditShiftAccess />} />
                                <Route path="shift/add-edit/:id" element={<AddEditShiftAccess />} />

                                {/** GeoFence -> Create/Update **/}
                                <Route path="geofence/create/" element={<CreateGeoFenceAttendance />} />
                                <Route path="geofence/update/:id" element={<UpdateGeoFenceAttendance />} />
                            </Route>

                            {/* @back up */}
                            <Route path='backup' element={<BackUp />} />
                            {/* @access */}
                            <Route path='access' element={<Access />} />
                            {/* @distribution */}
                            <Route path='distribution-center-panel' element={<DistributionCenter />} />
                            {/* @service-type */}
                            <Route path='service-type-panel' element={<ServiceType />} />
                            {/* @transport-request employee */}
                            <Route path='transport-request-panel' element={<TransportRequest />} />
                            <Route path='transport-request-panel' element={<PayrollOutlet />}>
                                <Route path='create' element={<CreateUpdateRequest />} />
                                <Route path='update/:id' element={<CreateUpdateRequest />} />
                            </Route>
                            {/* @logs */}
                            <Route path='logs' element={<Logs />} />
                            {/* holiday */}
                            <Route path='holiday' element={<Holiday />} />
                            {/* work-office */}
                            <Route path='work-office' element={<WorkOffice />} />
                            {/* material-request-scanner */}
                            <Route path='material-request-scanner' element={<MaterialRequestScanner />} />
                            {/* card-designer */}
                            <Route path='card-designer' element={<CardDesignerPanel />} />
                            <Route path='card-designer' element={<CardDesignerOutlet />}>
                                <Route path='create-template' element={<CreateTemplate />} />
                                <Route path='email-setting' element={<EmailSetting />} />
                            </Route>
                            {/* @hospitality */}
                            <Route path='hospitality' element={<Hospitality />} />
                            <Route path='hospitality' element={<HospitalityOutlet />}>
                                <Route path='add-room' element={<AddUpdateHospitality />} />
                                <Route path='room-detail' element={<RoomDetail />} />
                            </Route>
                            {/* @Departments */}
                            <Route path='departments' element={<Department />} />
                            {/* @Traffic */}
                            <Route
                                path='traffic'
                                element={
                                    <ParamsContextProvider>
                                        <TrafficOutlet />
                                    </ParamsContextProvider>
                                }
                            >
                                {/* default route when user visits /traffic */}

                                <Route index element={<TrafficMain />} />
                                <Route path='details/:id' element={<TrafficDetails />} />
                                <Route path='geofences/create' element={<GeofencesCreate/>} />
                                <Route path='geofences/update/:id' element={<GeofencesUpdate/>} />

                            </Route>


                            {/* @Visitor Management */}
                            {
                                roleName === ROLE_NAME_DEFAULT_MODEL.ROLE_GUARD ? (
                                    <>
                                        {/* @Visitors Management */}
                                        <Route path="guard" element={<Guard />} />
                                        <Route path='guard' element={
                                            <ParamsContextProvider>
                                                <GuardOutlet />
                                            </ParamsContextProvider>
                                        }>
                                            <Route path='visitor' element={<GuardMain/>} />
                                        </Route>
                                        <Route path="incoming-invitation" element={<VisitorIncomingInvitation />} />
                                        <Route path="incoming-contractors" element={<IncomingContractors/>} />

                                    </>
                                ) : (
                                    <Route path="visitor" element={<VisitorMain />} />
                                )
                            }
                            <Route path='visitor-type/create' element={<CreateVisitorType />} />
                            <Route path='visitor-type/update/' element={<UpdateVisitorType />} />
                            <Route path='visitor-invitation/create' element={<CreateVisitorInvitation />} />
                            <Route path='visitor' element={<VisitorOutlet />}>
                                <Route path='update' element={<VisitorUpdate />} />
                            </Route>
                            <Route path='visitor-invitation/visitor-public-detail/:id' element={<InvitationDetails />} />
                            <Route path='visitor-request' element={<InvitationDetails />}/>
                            <Route path='visitor-request' element={<InvitationDetailsOutlet />}>
                                <Route path='invitation-documentation' element={<InvitationDocumentation />} />
                                <Route path='invitation-identity' element={<InvitationIdentity />} />
                            </Route>
                            <Route path='material-request' element={<MaterialRequestOutlet />}>
                                <Route path='' element={<MaterialRequestMain />} />
                                <Route path='create' element={<CreateMaterialRequest />} />
                                <Route path='approval-tracker/:id' element={<ApprovalMaterialRequest />} />
                                <Route path='details/:id' element={<MaterialRequestDetails />} />
                                <Route path='dispatch/:id' element={<MaterialDispatch />} />
                            </Route>

                            {/* Restriction  */}
                            <Route path='user-restriction' element={<UserRestriction />} />
                            <Route path='vcard-settings' element={<VCardSettings />} />
                            <Route path='document-vehicle-restriction' element={<DocumentRestriction />} />
                            <Route path='document-restriction' element={<DocumentRestriction />} />
                            <Route path='contractor-restriction' element={<RestrictionUsers userType={contractorFile} />}/>
                            <Route path='supplier-restriction' element={<RestrictionUsers userType={supplierFile} />} />
                        </Route>
                    </Route>

                    {/* @Provider route start */}
                    <Route element={<RequireAuth allowedRoles={['SUPPLIER_IN_CHARGE']} />}>
                        <Route path='supplier' element={<ProviderLayout />}> {/**Done**/}
                            <Route path='profile' element={<ProfileProvider />} />
                            <Route path='employees' element={<AllEmployees/>}/> {/**Done**/}
                            <Route path='vehicles' element={<AllVehicles/>}/> {/**Done**/}
                            <Route path='company-documentation' element={<CompanyDocumentation profile={PROFILE_MODEL.COMPANY}/>} />
                            <Route path='employee/company-documentation/:id'
                                   element={<CompanyDocumentation profile={PROFILE_MODEL.EMPLOYEE}/>}/>
                            <Route path='vehicle/company-documentation/:id'
                                   element={<CompanyDocumentation profile={PROFILE_MODEL.VEHICLE}/>}/>
                            <Route path='create-employee' element={<SupplierFlowEmployeeCreate/>}/> {/**Done**/}
                            <Route path='update-employee/:id' element={<SupplierFlowEmployeeUpdate/>}/> {/**Done**/}
                            <Route path='add-vehicles' element={<CreateVehicle isUpdate={false}/>}/> {/**Done**/}
                            <Route path='update-vehicles/:id' element={<UpdateVehicle/>}/> {/**Done**/}
                            <Route path='supplier-employee-details/:id' element={<EmployeeDetailsDocumentation userType={USER_TYPE_MODEL.SUPPLIER_IN_CHARGE}/>}/> {/** Done: View details of a supplier employee  **/}
                            <Route path='supplier-vehicle-detail/:id' element={<VehicleDetailsDocumentation userType={USER_TYPE_MODEL.SUPPLIER_IN_CHARGE}/>}/> {/**Done**/}
                            <Route path='identity-validation/:id' element={<IdentityDocumentsGrid/>} />
                            {statusId !== STATUS_MODEL.TO_APPROVE_DOCUMENT &&
                            <>
                                <Route path='orders' element={<ProvidersPanel/>}/> {/**Done**/}
                                <Route path='foodie' element={<ContractorSupplierFoodieMain/>}/> {/**Done**/}
                                <Route path='errors-employee' element={<CreationErrorsSuplierEmployee/>}/> {/**Done**/}
                                <Route path='errors-vehicle' element={<CreationErrorsSuplierVehicle/>}/> {/**Done**/}
                                <Route path='complete-order/:id'
                                       element={<CompleteOrder isUpdateOrder={false}/>}/> {/**Done**/}
                                <Route path='update-order/:id'
                                       element={<CompleteOrder isUpdateOrder={true}/>}/> {/**Done**/}
                                <Route path='supplier-order-detail/:id'
                                       element={<SupplierFlowSupplierOrderDetail/>}/> {/**Done**/}
                                <Route path='order-detail/:id' element={<OrderDetail/>}/> {/**Done**/}
                                <Route path='announcements' element={<NotificationPanel/>}/>
                                <Route path='transport-request-panel' element={<TransportRequest/>}/>
                                <Route path='transport-request-panel' element={<PayrollOutlet/>}>
                                    <Route path='create' element={<CreateUpdateRequest/>}/>
                                    <Route path='update/:id' element={<CreateUpdateRequest/>}/>
                                </Route>
                                <Route path='meals' element={<SelectionMeals/>}/>
                                <Route path='basket' element={<BasketResume/>}/>
                            </>
                            }
                        </Route>
                    </Route>

                    {/* contrator route start */}
                    <Route element={<RequireAuth allowedRoles={['CONTRACTOR_IN_CHARGE']} />}>
                        <Route path='contractor' element={<ContratorLayout />}>
                            <Route path='profile' element={<ProfileProvider />} />
                            <Route path='company-documentation' element={<CompanyDocumentation profile={PROFILE_MODEL.COMPANY}/>} />
                            <Route path='search-employe' element={<AllEmployees />} />
                            <Route path='search-vehicle' element={<AllVehicles />} />
                            <Route path='employee/company-documentation/:id' element={<CompanyDocumentation profile={PROFILE_MODEL.EMPLOYEE}/>} />
                            <Route path='vehicle/company-documentation/:id' element={<CompanyDocumentation profile={PROFILE_MODEL.VEHICLE}/>} />
                            <Route path='add-new-employe' element={<ContractorCreateEmployee />} />{/**Contractor Flow -> Employees -> Create**/}
                            <Route path='update-employee/:id' element={<ContractorUpdateEmployee />} />{/**Contractor Flow -> Employees -> Update**/}
                            <Route path='addvehical' element={<CreateVehicle isUpdate={false} />} />
                            <Route path='update-vehicle/:id' element={<UpdateVehicle />} />
                            <Route path='contractor-employee-detail/:id' element={<EmployeeDetailsDocumentation userType={USER_TYPE_MODEL.CONTRACTOR_IN_CHARGE} />} /> {/** Done: View details of a contractor employee  **/}
                            <Route path='contractor-vehicle-detail/:id' element={<VehicleDetailsDocumentation userType={USER_TYPE_MODEL.CONTRACTOR_IN_CHARGE} />} />{/**Contractor Flow: vehicles -> details**/}
                            <Route path='identity-validation/:id' element={<IdentityDocumentsGrid/>} />
                            { statusId !== STATUS_MODEL.TO_APPROVE_DOCUMENT &&
                                <>
                                    <Route path='upload-vehicle-documents/:id' element={<VehicalContractDetail />} />{/**Contractor Flow: Vehicles -> Complete documents**/}
                                    <Route path='foodie' element={<ContractorSupplierFoodieMain />} />
                                    <Route path='access-rights' element={<AccessRights userType={contractorFile} />} />
                                    <Route path='announcements' element={<NotificationPanel />} />
                                    <Route path='edit-profile/:id' element={<EditProfile />} />
                                    <Route path='errors-employee' element={<CreationErrorsContractorEmployee />} />
                                    <Route path='errors-vehicle' element={<CreationErrorsContractorVehicle />} />
                                    <Route path='contract-employee-detail/:contractId/:id' element={<EmployeeDetailsFromContractorFlowContract />} />{/**Contractor Flow:  contracts -> details-> employee details**/}
                                    <Route path='vehicle-contract-detail/:contractId/:id' element={<VehicleDetailsFromContractFlowContract />} />{/**Contractor Flow: contracts -> vehicles -> details**/}
                                    <Route path='contract-details/:contractId' element={<ContractDetails />} />
                                    <Route path='contracts' element={<ContractorPanel />} />
                                    <Route path='employee-upload-documents/:id' element={<EmployeContractDetail />} />{/**Contractor Flow -> Employees -> Complete documents***/}
                                    <Route path='meals' element={<SelectionMeals />} />
                                    <Route path='basket' element={<BasketResume />} />
                                    <Route path='equipment-and-materials' element={<EquipmentAndMaterial/>} />
                                    <Route path='equipment-and-materials/create/' element={<CreateEquipmentMaterial/>} />
                                    <Route path='equipment-and-materials/update/:id' element={<UpdateEquipmentMaterial/> } />
                                    <Route path='equipment-and-materials/details/:id' element={<DetailsEquipmentMaterial/> } />
                                </>
                            }
                        </Route>
                    </Route>
                </Route>
                {/* other prtected route */}
                <Route path='/login-option' element={<LoginOptions />} />:
            </Route>
            {/* other public route */}

            <Route path='invitation-details' element={<ExternalOutlet />}>
                <Route path=':id' element={<Invitation />} />
                <Route path=':id/:guardFlowId' element={<Invitation />} />
                <Route path='process/:id' element={<RegistrationProcess />} />
                <Route path='process/:id/:guardFlowId' element={<RegistrationProcess />} />
                <Route path='validation/:id' element={<IdentityValidation />} />
                <Route path='validation/:id/:guardFlowId' element={<IdentityValidation />} />
                <Route path='documentation-validation/:id' element={<DocumentationValidation />} />
                <Route path='documentation-validation/:id/:guardFlowId' element={<DocumentationValidation />} />
                <Route path='create-documentation/:id' element={<CreateDocumentation />} />
                <Route path='create-documentation/:id/:guardFlowId' element={<CreateDocumentation />} />
                <Route path='choose-validation/:id' element={<ChooseValidationType />} />
                <Route path='choose-validation/:id/:guardFlowId' element={<ChooseValidationType />} />
                <Route path='create/:type/:id' element={<CreateValidation />} />
                <Route path='create/:type/:id/:guardFlowId' element={<CreateValidation />} />
                <Route path='under-review/:id' element={<CurrentlyUnderReview />} />
                <Route path='under-review/:id/:guardFlowId' element={<CurrentlyUnderReview />} />
                <Route path='successfully-verified/:id' element={<SuccessfullyVerified />} />
                <Route path='successfully-verified/:id/:guardFlowId' element={<SuccessfullyVerified />} />
                <Route path='documentation-validation/under-review/:id' element={<DocumentationUnderReview />} />
                <Route path='documentation-validation/under-review/:id/:guardFlowId' element={<DocumentationUnderReview />} />
            </Route>

            <Route path="qr-request-access" element={<QrRequestAccessOutlet />}>
                <Route index element={<QrRequestAccessMain />} />
                <Route path='find-my-self' element={<FindMySelfMain />} />
                <Route path='find-my-self-create-visitor' element={<FindMySelfCreateVisitorMain />} />
                <Route path='i-am-new-here' element={<IAmNewHereMain />} />
            </Route>

            <Route path='/' element={<Home />} />
            <Route path='/*' element={<NotFound />} />
            <Route path='/unauthorized' element={<Unauthorized />} />
            <Route path='/forbidden' element={<Forbidden />} />
            <Route path='/download-apk' element={<DownloadApk />} />
        </Routes>
    );
};

export default MainRoutes;
